var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dmpi"}},[_c('drawer'),_c('error-overlay'),_c('app-header'),_c('route-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }